import { CORE_TYPES, IMPORT_COL_TYPES } from '../share/Constants'
import AssetLiabilityModel, {
  baseAssetLiabilityColumns
} from './AssetLiabilityModel'
import i18next from 'i18next'

class Liability extends AssetLiabilityModel {
  /**
   * Construct a new Liability instance
   * @param {object} params - Liability creation options:
   * @param {date} [params.startDate]
   * @param {date} [params.maturityDate]
   * @param {number} [params.outstandingValueInLiabilityCurrency]
   * @param {number} [params.outstandingValueInBaseCurrency]
   */
  constructor({
    _id,
    _rev,
    _deleted,
    title,
    description,
    descriptionWithMarkup,
    percentageOwnership,
    startDate,
    maturityDate,
    currency,
    valuationDate,
    valuationDateInBaseCurrency,
    outstandingValueInLiabilityCurrency,
    outstandingValueInBaseCurrency,
    contacts,
    references,
    links,
    documents,
    includeValueInNetWorth,
    status,
    events,
    passwords,
    tags
  }) {
    super({
      _id,
      _rev,
      _deleted,
      title,
      description,
      descriptionWithMarkup,
      percentageOwnership,
      currency,
      valuationDate,
      valuationDateInBaseCurrency,
      contacts,
      references,
      links,
      documents,
      includeValueInNetWorth,
      status,
      events,
      passwords,
      tags
    })

    this.type = CORE_TYPES.LIABILITY
    this.startDate = startDate && startDate.startOf('day')
    this.maturityDate = maturityDate && maturityDate.startOf('day')
    this.outstandingValueInBaseCurrency = outstandingValueInBaseCurrency
    this.outstandingValueInLiabilityCurrency = outstandingValueInLiabilityCurrency
  }
}

export default Liability

export const liabilityColumns = () => [
  ...baseAssetLiabilityColumns(),
  {
    key: 'outstandingValueInLiabilityCurrency',
    type: IMPORT_COL_TYPES.CURRENCY,
    title: i18next.t('OUTSTANDING_VALUE_LIABILITY_CURRENCY')
  }
]
